import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";




import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";

import { ADD_MODE } from "../../utility/Constants";
import ApiList from "../../components/masters/api/ApiList";



const Api = () => {
   
  
  
    return (
      <div className="inside-main-content">
        <AdminBreadCrumb />
  
        <div className="box-style">
          <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Api"
            subTitle=""
            extra={[
              // <Button key="1" type="primary" shape="round" onClick={showDrawer}>
              //   <PlusOutlined /> Add
              // </Button>,
            ]}
          ></PageHeader>
  
       
  
          <div className="form-content">
            <ApiList />
          </div>
  
        </div>
      </div>
    )
}

export default Api